var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFuelWallet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5378 6.18895H5.31689V26.8285H26.5378V6.18895Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.16238 3.5C4.24259 3.5 3.5 4.24259 3.5 5.16238V28.5H24.185C24.8842 28.5 25.5565 28.2223 26.0515 27.7273L27.7273 26.0515C28.2223 25.5565 28.5 24.8842 28.5 24.185V3.5H5.16238ZM19.8233 6.71446L11.6917 14.846C11.491 15.0467 11.2167 15.1604 10.9324 15.1604C10.5177 15.1604 10.1363 14.9196 9.95903 14.5449L6.8081 7.88519C6.55055 7.33999 6.94858 6.71446 7.55068 6.71446H19.8233ZM6.71446 25.2855V17.3747C6.71446 16.9533 7.05565 16.6121 7.4771 16.6121H15.3879L6.71446 25.2855ZM16.0435 15.1604H13.4243L21.3051 7.27977C21.6663 6.91847 22.158 6.71446 22.6698 6.71446H25.2888L17.4082 14.5951C17.047 14.9564 16.5552 15.1604 16.0435 15.1604Z",
    fill: "#00F58C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFuelWallet);
export default __webpack_public_path__ + "static/media/icon-fuel-wallet.5dbe4613b9e1093e47e9a3b01e81c510.svg";
export { ForwardRef as ReactComponent };